<template>
  <div class="container pb-5 pt-4 mb-3">
    <div class="tab-content" id="nav-tabContent">
      <div class="tab-pane fade active show" id="nav-order" role="tabpanel" aria-labelledby="nab-order-tab">
        <div class="card shadow rounded rounded-3 mb-3" v-for="transaction in transactions" :key="transaction">
          <div class="card-header bg-secondary p-0">
            <p class="text-center fw-bold text-white pt-2 pb-0">{{ transaction.date_group }}</p>
          </div>
          <div class="card-body">
            <div class="" v-for="(tester_data, index) in transaction.tester" :key="tester_data">
              <div class="d-flex justify-content-between align-items-center">
                <div class="">
                  <table>
                    <tbody>
                      <tr>
                        <td class="pe-2"><i class="bi bi-person-fill text-primary"></i></td>
                        <td>
                          <b>{{ tester_data.fullname }}</b> ({{ tester_data.email }})
                        </td>
                      </tr>
                      <tr>
                        <td class="pe-2"><i class="bi bi-book-fill text-primary"></i></td>
                        <td>{{ tester_data.package_name }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="" v-if="tester_data.status_process === 'draft' || tester_data.status_process === 'retake'">
                  <button
                    @click="direct_test(tester_data)"
                    class="btn btn-primary shadow text-white rounded ripple fs-6">
                    {{ $t('takeATest') }}
                  </button>
                </div>
                <div
                  class="align-self-center text-success text-center"
                  style="font-size: 11pt"
                  v-else-if="tester_data.status_process === 'queued up'">
                  <button
                    class="btn btn-warning shadow rounded ripple"
                    @click="doPayment(tester_data.id, tester_data.package_name, tester_data.total_price)">
                    {{ $t('checkout') }}
                  </button>
                </div>
                <div class="align-self-center text-success text-center" v-else>{{ $t('testDone') }}</div>
              </div>
              <hr v-if="index !== Object.keys(transaction.tester).length - 1" />
            </div>
          </div>
        </div>
        <div v-if="transactions.length === 0" class="text-center mt-5">
          <i class="bi bi-archive fs-1 text-muted"></i>
          <p class="text-muted mt-3">{{ $t('noTransaction') }}</p>
        </div>
      </div>
      <div class="tab-pane fade" id="nav-result" role="tabpanel" aria-labelledby="nab-result-tab">
        <p class="text-center mt-3 text-muted" style="font-size: 9pt" v-if="this.$store.getters.getRole !== 'hr'">
          {{ $t('testResultMsg.email') }}
        </p>
        <p class="text-center mt-3 text-muted" style="font-size: 9pt" v-else>
          {{ $t('testResultMsg.corporate') }}
        </p>
      </div>
    </div>
  </div>

  <BottomNav />
</template>

<script>
import BottomNav from '../components/BottomNav'
import axios from 'axios'
import Swal from 'sweetalert2'

export default {
  name: 'Transactions',
  components: { BottomNav },
  data() {
    return {
      transactions: [],
      invoices: [],
      reports: [],
    }
  },
  created() {
    let self = this
    const handleSessionError = (error) => {
      console.log(error)
      if (error.response && error.response.status === 403) {
        Swal.fire({
          icon: 'info',
          title: self.$t('sessionExpired'),
          text: self.$t('sessionExpiredDesc'),
          confirmButtonText: self.$t('signin'),
        }).then(() => {
          self.$store.dispatch('setAuth', false)
          self.$router.push('/')
        })
      }
    }

    let is_hr = this.$store.getters.getRole === 'hr' ? '?is_hr=yes' : ''
    axios
      .get('/api/transaction' + is_hr, { withCredentials: true })
      .then((response) => {
        self.transactions = response.data
      })
      .catch(handleSessionError)
    if (this.$store.getters.getRole !== 'hr') {
      axios
        .get('/api/invoice', { withCredentials: true })
        .then((response) => {
          self.invoices = response.data
        })
        .catch(handleSessionError)
      axios
        .get('/api/report', { withCredentials: true })
        .then((response) => {
          self.reports = response.data
        })
        .catch(handleSessionError)
    }
  },
  methods: {
    doPayment(transaction_id, package_name, total_price) {
      Swal.fire({
        title: this.$t('checkoutQuestion'),
        showCancelButton: true,
        confirmButtonText: this.$t('confirmation.yes'),
        cancelButtonText: this.$t('confirmation.no'),
      }).then((result) => {
        if (result.isConfirmed) {
          this.processIndividualPayment(transaction_id, package_name, total_price)
        }
      })
    },
    async processIndividualPayment(transaction_id, package_name, total_price) {
      try {
        const response = await axios.post('/api/create_invoice_pg', {
          user_id: this.$store.getters.getUser.id,
          transaction_id: transaction_id,
          package_name: package_name,
          price: total_price,
        })

        const formData = {
          payment_id: response.data.id,
          payment_url: response.data.url,
          trx_id: transaction_id,
          price_sum: total_price,
          package_name: package_name,
        }
        
        this.$store.dispatch('setCheckout', formData)
        this.$router.push('/payment/checkout')
      } catch (error) {
        Swal.fire('Error', this.$t('checkoutFailed'), 'error')
        console.error('Payment error:', error)
      }
    },
    direct_test(tester_data) {
      this.$store.dispatch('setTransaction', tester_data.id)
      this.$router.push({ name: 'Upload Finger' })
    },
  },
}
</script>

<style scoped>
table {
  font-size: 8pt;
}

.nav-link {
  border-radius: 0 !important;
  background: white !important;
  color: #6c757d !important;
  border-bottom: 3px solid #6c757d !important;
}

.nav-link.active {
  color: #0d6efd !important;
  border-bottom: 3px solid #0d6efd !important;
}
</style>
